import DataTable from "./DataTable";
import { useDataTable } from "./useDataTable";

/** Tabela sem filtros externos: hook + DataTable. */
const SimpleTable = ({ tableKey, columns, data, ...props }) => {
    const { table, resetLayout } = useDataTable({ tableKey, columns, data });
    return <DataTable table={table} resetLayout={resetLayout} {...props} />;
};

export default SimpleTable;
